import React, { useCallback, useRef, useState } from 'react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule, EmailRule, AsyncRule, StringLengthRule, PatternRule, CompareRule } from 'devextreme-react/validator';

import { useGoogleLogin } from '@react-oauth/google';
import Button from 'devextreme-react/button';
// import CheckBox from 'devextreme-react/check-box';
import './index.scss';
import { Link } from 'react-router-dom';
import cs from '../../utils/const.js';
import AntString from '../../utils/AntString.js';
import AntTime from '../../utils/AntTime.js';
import AntAuth from '../../utils/AntAuth';
import AntLocalization from '../../utils/AntLocalization';
import AntErrorPanel from '../AntErrorPanel';
import AntCardLayout from '../AntCardLayout';
import AntTitlePanel from '../AntTitlePanel';
import AntDescPanel from '../AntDescPanel';
import md5 from 'md5';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';
import GoogleLoginButton from './GoogleLoginButton';
import AccountLoginQRCode from './AccountLoginQRCode';

export default function (props) {
    const appGlobal = AntGlobal();
    const [busShortCode, setBusShortCode] = useState(cs.Business_Short_Code ? cs.Business_Short_Code : '');
    const hasBusShortCode = Boolean(cs.Business_Short_Code);
    const isWhiteLabel = Boolean(cs.Is_White_Label);
    const [errorText, setErrorText] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [processing, setProcessing] = useState(false);

    const validationGroup = useRef();
    const txtUserName = useRef();
    const txtPassword = useRef();

    if (!AntTime.isValidLicenseTime()) console.log('Your License is expired! Please contact to trung.dao@ante.vn');

    const { appInfo, appAssets } = appGlobal;
    var title = appInfo && appInfo.title ? appInfo.title : '';
    var logoOnly = appAssets && appAssets.images.logoOnly ? appAssets.images.logoOnly : undefined;
    var logoWithBrand =
        appAssets && appAssets.images.authLogoTagline
            ? appAssets.images.authLogoTagline
            : appAssets && appAssets.images.logoWithBrandSlogun
            ? appAssets.images.logoWithBrandSlogun
            : undefined;

    var isValidLicenseTime = AntTime.isValidLicenseTime();

    const businessCodeChanged = (e) => {
        setBusShortCode(e.value);
    };

    const onUserNameChanged = (e) => {
        setUserName(e.value);
    };

    const onPasswordChanged = (e) => {
        setPassword(e.value);
    };

    const onLogin = () => {
        if (validationGroup.current && !validationGroup.current.instance.validate().isValid) {
            return;
        }
        setErrorText(null);
        setProcessing(true);

        AntAuth.logIn(
            {
                app_id: appGlobal.appInfo.appId,
                busShortCode: busShortCode,
                user_name: userName,
                password: md5(AntString.clean(password))
            },
            (res) => {
                if (res && res.error) {
                    setErrorText(res.error);
                    setProcessing(false);
                    setUserName(userName);
                } else {
                    if (props.onLogged) props.onLogged(res);
                }
            }
        );
    };

    const loginWithGoogle = useGoogleLogin({
        flow: 'auth-code',
        onSuccess: async (data) => {
            console.log('ant-log-loginWithGoogle : ', data);

            setErrorText(null);
            setProcessing(true);

            AntAuth.logIn(
                {
                    type: 'WithGoogleAccount',
                    app_id: appGlobal.appInfo.appId,
                    busShortCode: busShortCode,
                    googleCode: data.code
                },
                (res) => {
                    if (res && res.error) {
                        setErrorText(res.error);
                        setProcessing(false);
                    } else {
                        if (props.onLogged) props.onLogged(res);
                    }
                }
            );
        }
    });
    if (processing || !isValidLicenseTime)
        return (
            <div>
                <LoadPanel
                    position={{ of: '#root' }}
                    visible={true}
                    showPane={false}
                    shading={false}
                    // shadingColor={'rgba(255, 255, 255, 1)'}
                    // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}
                    wrapperAttr={{
                        class: 'ant-loading'
                    }}
                />
            </div>
        );

    return (
        <AntCardLayout width={380} scale={1.0} marginLeft={props.marginLeft} marginRight={props.marginRight}>
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <ValidationGroup ref={validationGroup} className={'login-panel'}>
                    <div className={'login-header'}>
                        {!logoWithBrand && <div className={'title'}>{appInfo.title}</div>}
                        {logoWithBrand && <img src={logoWithBrand} style={{ width: '140px' }} />}
                    </div>

                    {!processing && !isWhiteLabel && hasBusShortCode && (
                        <div className={'dx-field'}>
                            <AntTitlePanel text={busShortCode} center={true} upper={true} />
                        </div>
                    )}

                    {/* {!hasBusShortCode && (
                            <div className={'dx-field'}>
                                <TextBox
                                    ref={(ref) => {
                                        this.txtBus = ref ? ref.instance : undefined;
                                    }}
                                    value={busShortCode}
                                    readOnly={Boolean(hasBusShortCode)}
                                    focusStateEnabled={!Boolean(hasBusShortCode)}
                                    onValueChanged={this.businessCodeChanged.bind(this)}
                                    placeholder={'Mã Doanh Nghiệp'}
                                    width={'100%'}
                                    className={'login-bus'}
                                    onContentReady={(e) => {
                                        if (!Boolean(hasBusShortCode))
                                            setTimeout(() => {
                                                e.component.focus();
                                            });
                                    }}
                                    onEnterKey={(e) => {
                                        this.txtUserName.focus();
                                    }}
                                >
                                    <Validator>
                                        <RequiredRule message={'Không được trống !'} />
                                        <StringLengthRule message="Tối thiểu 5 ký tự" min={5} />
                                        <StringLengthRule message="Tối đa 20 ký tự" max={20} />
                                        <PatternRule
                                            message="Không được chứa ký tự đặc biệt !"
                                            pattern={'^[^\\`~!@#$%^&*()=+\\[\\]{}\\|;\':",.<>?/]+$'}
                                        />
                                        <PatternRule message="Không được nhập khoảng trắng !" pattern={/^[^\s]+$/} />
                                        <AsyncRule
                                            message={'Mã doanh nghiệp không tồn tại !'}
                                            validationCallback={async (e) => {
                                                if (this.state.blockValidation) return true;
                                                this.state.blockValidation = true;
                                                var isExisted = await AntBusiness.isShortCodeExisted(String(e.value));
                                                this.state.blockValidation = false;
                                                return Boolean(isExisted);
                                            }}
                                        />
                                    </Validator>
                                    <TextBoxButton
                                        name="busCode"
                                        location="before"
                                        options={{
                                            icon: 'product',
                                            stylingMode: 'text',
                                            focusStateEnabled: false,
                                            activeStateEnabled: false,
                                            hoverStateEnabled: false,
                                            type: 'default'
                                        }}
                                    />
                                </TextBox>
                            </div>
                        )} */}
                    <div
                        className={'dx-field'}
                        style={{
                            visibility: processing ? 'hidden' : 'visible'
                        }}
                    >
                        <TextBox
                            ref={txtUserName}
                            value={userName}
                            onValueChanged={onUserNameChanged}
                            placeholder={AntLocalization.translateText({
                                vi: 'Tài khoản',
                                en: 'User name',
                                fr: "Identifiant",
                                es: 'Usuario',
                                id: 'Nama pengguna',
                                ja: 'ユーザー名',
                                zh: '用户名',
                                ko: '사용자 이름',
                                hi: 'उपयोगकर्ता नाम',
                                ar: 'اسم المستخدم'
                            })}
                            width={'100%'}
                            className={'login-account'}
                            onContentReady={(e) => {
                                if (Boolean(hasBusShortCode))
                                    setTimeout(() => {
                                        e.component.focus();
                                    });
                            }}
                            onEnterKey={(e) => {
                                if (txtPassword.current && txtPassword.current.instance) txtPassword.current.instance.focus();
                            }}
                        >
                            <Validator>
                                <RequiredRule
                                    message={AntLocalization.translateText({
                                        vi: 'Không được trống !',
                                        en: 'Cannot be empty!',
                                        fr: 'Ne peut pas être vide !',
                                        es: '¡No puede estar vacío!',
                                        id: 'Tidak boleh kosong!',
                                        ja: '空にできません！',
                                        zh: '不能为空！',
                                        ko: '비워둘 수 없습니다!',
                                        hi: 'खाली नहीं हो सकता!',
                                        ar: 'لا يمكن أن يكون فارغاً!'
                                    })}
                                />
                                <StringLengthRule
                                    message={AntLocalization.translateText({
                                        vi: 'Tối thiểu 5 ký tự',
                                        en: 'Minimum 5 characters',
                                        fr: 'Minimum 5 caractères',
                                        es: 'Mínimo 5 caracteres',
                                        id: 'Minimal 5 karakter',
                                        ja: '最低5文字',
                                        zh: '至少5个字符',
                                        ko: '최소 5자',
                                        hi: 'न्यूनतम 5 वर्ण',
                                        ar: '5 أحرف على الأقل'
                                    })}
                                    min={5}
                                />
                                <StringLengthRule
                                    message={AntLocalization.translateText({
                                        vi: 'Tối đa 64 ký tự',
                                        en: 'Maximum 64 characters',
                                        fr: '64 caractères maximum',
                                        es: 'Máximo 64 caracteres',
                                        id: 'Maksimal 64 karakter',
                                        ja: '最大64文字',
                                        zh: '最多64个字符',
                                        ko: '최대 64자',
                                        hi: 'अधिकतम 64 वर्ण',
                                        ar: '64 حرفًا كحد أقصى'
                                    })}
                                    max={64}
                                />
                                <PatternRule
                                    message={AntLocalization.translateText({
                                        vi: 'Không được chứa ký tự đặc biệt !',
                                        en: 'Special characters are not allowed!',
                                        fr: 'Les caractères spéciaux ne sont pas autorisés !',
                                        es: '¡No se permiten caracteres especiales!',
                                        id: 'Karakter khusus tidak diizinkan!',
                                        ja: '特殊文字は使用できません！',
                                        zh: '不允许使用特殊字符！',
                                        ko: '특수 문자는 허용되지 않습니다!',
                                        hi: 'विशेष वर्णों की अनुमति नहीं है!',
                                        ar: 'الأحرف الخاصة غير مسموح بها!'
                                    })}
                                    pattern={'^[^\\`~!#$%^&*()=+\\[\\]{}\\|;\':",<>?/]+$'}
                                />
                            </Validator>
                            <TextBoxButton
                                name="userCode"
                                location="before"
                                options={{
                                    icon: 'user',
                                    stylingMode: 'text',
                                    focusStateEnabled: false,
                                    activeStateEnabled: false,
                                    hoverStateEnabled: false,
                                    type: 'default'
                                }}
                            />
                        </TextBox>
                    </div>
                    <div
                        className={'dx-field'}
                        style={{
                            visibility: processing ? 'hidden' : 'visible'
                        }}
                    >
                        <TextBox
                            ref={txtPassword}
                            mode={'password'}
                            value={password}
                            onValueChanged={onPasswordChanged}
                            onEnterKey={onLogin}
                            placeholder={AntLocalization.translateText({
                                vi: 'Mật khẩu',
                                en: 'Password',
                                fr: 'Mot de passe',
                                es: 'Contraseña',
                                id: 'Kata sandi',
                                ja: 'パスワード',
                                zh: '密码',
                                ko: '비밀번호',
                                hi: 'पासवर्ड',
                                ar: 'كلمة المرور'
                            })}
                            width={'100%'}
                            className={'login-password'}
                        >
                            <Validator>
                                <RequiredRule
                                    message={AntLocalization.translateText({
                                        vi: 'Không được trống !',
                                        en: 'Cannot be empty!',
                                        fr: 'Ne peut pas être vide !',
                                        es: '¡No puede estar vacío!',
                                        id: 'Tidak boleh kosong!',
                                        ja: '空にできません！',
                                        zh: '不能为空！',
                                        ko: '비워둘 수 없습니다!',
                                        hi: 'खाली नहीं हो सकता!',
                                        ar: 'لا يمكن أن يكون فارغاً!'
                                    })}
                                />
                                <StringLengthRule
                                    message={AntLocalization.translateText({
                                        vi: 'Tối thiểu 6 ký tự',
                                        en: 'Minimum 6 characters',
                                        fr: '6 caractères minimum',
                                        es: 'Mínimo 6 caracteres',
                                        id: 'Minimal 6 karakter',
                                        ja: '最低6文字',
                                        zh: '至少6个字符',
                                        ko: '최소 6자',
                                        hi: 'न्यूनतम 6 वर्ण',
                                        ar: '6 أحرف على الأقل'
                                    })}
                                    min={6}
                                />
                                <StringLengthRule
                                    message={AntLocalization.translateText({
                                        vi: 'Tối đa 64 ký tự',
                                        en: 'Maximum 64 characters',
                                        fr: '64 caractères maximum',
                                        es: 'Máximo 64 caracteres',
                                        id: 'Maksimal 64 karakter',
                                        ja: '最大64文字',
                                        zh: '最多64个字符',
                                        ko: '최대 64자',
                                        hi: 'अधिकतम 64 वर्ण',
                                        ar: '64 حرفًا كحد أقصى'
                                    })}
                                    max={64}
                                />
                            </Validator>
                            <TextBoxButton
                                name="keyCode"
                                location="before"
                                options={{
                                    icon: 'key',
                                    stylingMode: 'text',
                                    focusStateEnabled: false,
                                    activeStateEnabled: false,
                                    hoverStateEnabled: false,
                                    type: 'default'
                                }}
                            />
                        </TextBox>
                    </div>
                    <div
                        className={'dx-field'}
                        style={{
                            visibility: processing ? 'hidden' : 'visible'
                        }}
                    >
                        <Button
                            className={'login-button'}
                            type={'default'}
                            text={AntLocalization.translateText({
                                vi: 'ĐĂNG NHẬP',
                                en: 'LOGIN',
                                fr: 'CONNEXION',
                                es: 'ACCEDER',
                                id: 'MASUK',
                                ja: 'ログイン',
                                zh: '登录',
                                ko: '로그인',
                                hi: 'लॉगिन',
                                ar: 'تسجيل الدخول'
                            })}
                            onClick={onLogin}
                            width={'100%'}
                            style={{ fontWeight: 500 }}
                        />
                    </div>
                    {/* <div className={'dx-field'} style={{ marginLeft: '-18px', visibility: !errorText ? 'hidden' : 'visible' }}> */}
                    <AntErrorPanel text={errorText} />
                    {/* </div> */}

                    <div className={'dx-field'} style={{ justifySelf: 'center', marginTop: 5, fontSize: '11px', color: '#6a6767' }}>
                        {AntLocalization.translateText({
                            vi: 'hoặc',
                            en: 'or',
                            fr: 'ou',
                            es: 'o',
                            id: 'atau',
                            ja: 'または',
                            zh: '或',
                            ko: '또는',
                            hi: 'या',
                            ar: 'أو'
                        })}
                    </div>
                    <div className={'dx-field'} style={{ justifyContent: 'center', marginTop: 0, marginBottom: 5, display: 'flex' }}>
                        <GoogleLoginButton onClick={loginWithGoogle} />
                    </div>
                    <div className="login-qr-code">
                        <div className="login-qr-code__description">
                            {AntLocalization.translateText({
                                vi: 'Quét mã từ ứng dụng trên điện thoại',
                                en: 'Scan the code from the mobile app',
                                fr: 'Scannez le code depuis l’application mobile',
                                es: 'Escanea el código desde la aplicación móvil',
                                id: 'Pindai kode dari aplikasi seluler',
                                ja: 'モバイルアプリからコードをスキャン',
                                zh: '使用手机应用扫描二维码',
                                ko: '모바일 앱에서 코드를 스캔하세요',
                                hi: 'मोबाइल ऐप से कोड स्कैन करें',
                                ar: 'امسح الرمز من تطبيق الهاتف'
                            })}
                        </div>
                        <AccountLoginQRCode onLogged={props.onLogged} />
                    </div>
                </ValidationGroup>
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'center',
                        marginTop: 15
                    }}
                >
                    <div className={'dx-field'} style={{ justifySelf: 'center', minHeight: 26 }}>
                        <Link to={'/recovery'}>
                            {AntLocalization.translateText({
                                vi: 'Quên hoặc chưa đặt mật khẩu quản trị ?',
                                en: 'Forgot or never set your admin password?',
                                fr: 'Mot de passe admin oublié ou jamais défini ?',
                                es: '¿Olvidó o aún no definió su contraseña de administrador?',
                                id: 'Lupa atau belum mengatur kata sandi admin?',
                                ja: '管理者パスワードを忘れた、または未設定ですか？',
                                zh: '忘记或尚未设置管理员密码？',
                                ko: '관리자 비밀번호를 잊었거나 아직 설정하지 않으셨나요?',
                                hi: 'व्यवस्थापक पासवर्ड भूल गए या अभी तक सेट नहीं किया?',
                                ar: 'هل نسيت كلمة مرور المسؤول أو لم تعيّنها بعد؟'
                            })}
                        </Link>
                    </div>
                    {!hasBusShortCode && (
                        <div className={'dx-field'} style={{ justifySelf: 'center', minHeight: 26  }}>
                            <Link to={'/register'}>
                                {AntLocalization.translateText({
                                    vi: 'Đăng ký để bắt đầu kinh doanh',
                                    en: 'Sign up to start your business',
                                    fr: "S'inscrire pour démarrer votre entreprise",
                                    es: 'Regístrese para iniciar su negocio',
                                    id: 'Daftar untuk memulai bisnis Anda',
                                    ja: 'ビジネスを始めるために登録',
                                    zh: '注册开始您的业务',
                                    ko: '비즈니스를 시작하려면 가입하세요',
                                    hi: 'अपना व्यवसाय शुरू करने के लिए साइन अप करें',
                                    ar: 'سجّل لبدء عملك'
                                })}
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </AntCardLayout>
    );
}
